'use client';

import { ThemeProvider } from '@mui/material/styles';
import { AppThemes } from './allThemes';
import { AppName } from '../utils/appNames';
import { AppNameProvider } from '../lib/AppNameProvider';

interface ThemeWrapperProps {
    /* Props for ThemeWrapper component including children and app name for theme selection. */

    children: React.ReactNode;
    appName: AppName;
}

// THEME WRAPPER
export default function ThemeWrapper({ children, appName }: ThemeWrapperProps) {
    /* Client component that selects and provides the appropriate Material-UI theme based on the provided app name. */

    const theme = AppThemes[appName] ?? AppThemes[AppName.IceAI];

    return (
        <AppNameProvider appName={appName}>
            <ThemeProvider theme={theme}>
                {children}
            </ThemeProvider>
        </AppNameProvider>
    );
}
